const LOCATIONIQ_KEY = 'pk.c7c56eae3d29c3404f2685d26982a017'; 

export const fetchAddressSuggestions = async (query) => {
    const url = `https://us1.locationiq.com/v1/autocomplete?key=${LOCATIONIQ_KEY}&q=${encodeURIComponent(query)}&limit=5&dedupe=1&normalizecity=1&countrycodes=us`;

  try {
    const res = await fetch(url);
    const data = await res.json();
    return data;
  } catch (err) {
    console.error('LocationIQ error:', err);
    
    return [];
  }
};
